module.exports = __webpack_public_path__ + "img/male_S_01.a49079a3.png";